import * as React from "react";
import { Block } from "baseui/block";

import { Modal } from "kanopi-components/Modal";
import { useGlobal } from "kanopi-components/useGlobal";

import { useTrackCoverAddCompleted } from "./useTracking";
import { CoverFlow } from "../../quoting/components/CoverFlow";
import { useGlobalsContext } from "../Globals";
import { useEditCoverSection } from "./useEditCoverSection";
import { useUpdateCoverEnabled } from "./useUpdateCoverEnabled";

type TCoverSectionModal = {
  riskProfileId: string;
  coverSection?: TCoverSection;
  title?: string;
  description?: string;
  prefix: string;
  onClose?: () => void;
  coverIsEnabled?: boolean;
  policyId?: string;
};

export const CoverSectionModal: React.FC<TCoverSectionModal> = ({
  riskProfileId,
  coverSection = {},
  prefix,
  onClose,
  coverIsEnabled = false,
  policyId,
  ...props
}) => {
  const globalsContext = useGlobalsContext();
  const [, setData] = useGlobal(globalsContext);
  const { setEnabled } = useUpdateCoverEnabled({ coverId: coverSection?.id });
  const { updating, coverId, exitEditing } = useEditCoverSection({
    coverSection,
    prefix,
  });

  const trackCoverAddCompleted = useTrackCoverAddCompleted();
  const enableCover = async () => {
    // TODO: This needs to refactored to happen in a single API call
    // (urgently). DO NOT move `exitEditing` to below the `await`. It
    // will break.
    exitEditing();
    await setEnabled(true);
    setData({ reprice: true });
    if (!coverSection.enabled) {
      trackCoverAddCompleted({ cover: coverSection, riskProfileId });
    }
    onClose?.();
  };

  const handleClose = () => {
    exitEditing();
    setData({ reprice: true });
    onClose?.();
  };

  if (!coverId) {
    return null;
  }

  return (
    <Modal open={updating} onCancel={handleClose} {...props}>
      {updating ? (
        <Block>
          <Modal.Body>
            <CoverFlow
              coverId={coverSection?.id}
              riskProfileId={riskProfileId}
              prefix={`${prefix}/cover/${coverId}`}
              onComplete={enableCover}
              coverEnabled={coverIsEnabled}
              finishedRoute={prefix}
              policyId={policyId}
            />
          </Modal.Body>
        </Block>
      ) : null}
    </Modal>
  );
};
